import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { WorksheetStateAction } from '../../core/domain';
import { HBox } from '../../core/layout';
import { TransitionStore } from '../../core/transition-api';
import React from 'react';
import { VisitContext, WorksheetApis } from '../../core';
import { Paper } from '@mui/material';

interface CodingActionsProps {
  transition: TransitionStore;
  actions: WorksheetStateAction[];
  worksheetId?: string;
  onComplete?: (action?: WorksheetStateAction) => void;
  onFailed?: () => void;
}

export function CodingActions(props: CodingActionsProps) {
  const { actions, transition, onComplete, onFailed } = props;

  const onTransition = async (v: WorksheetStateAction) => {
    try {
      const result = await transition.getState().transition(v);
      if (result && onComplete) {
        onComplete(v);
      } else {
        if (onFailed) {
          onFailed();
        }
      }
    } catch (e) {
      if (onFailed) {
        onFailed();
      }
    }
  };

  return (
    <HBox align={'flex-end'} containerStyle={{ root: { padding: '12px 18px 12px 12px' } }}>
      {actions.map((v, i) => (
        <Button key={i} id={v.label || v.action} variant="outlined" color="primary" onClick={() => onTransition(v)}>
          {v.label || v.action}
        </Button>
      ))}
    </HBox>
  );
}

type CodingActionsDialogueProps = CodingActionsProps & {
  label: string;
  context?: VisitContext;
};
export function CodingActionsDialogue(props: CodingActionsDialogueProps) {
  const { label, transition, context, worksheetId } = props;

  const transitionDialogueComplete = transition((s) => s.transitionDialogueComplete);
  const openTransitionDialogue = transition((s) => s.openTransitionDialogue);
  const onTransition = (a: WorksheetStateAction) => {
    transition.setState({ openTransitionDialogue: false });

    if (!worksheetId && transitionDialogueComplete) {
      transitionDialogueComplete(a);
    }
  };

  const close = () => {
    transition.setState({ openTransitionDialogue: false });
    if (context) {
      context.refreshRouteApis();
    }
  };

  return (
    <Dialog open={openTransitionDialogue} maxWidth={false} style={{ zIndex: 1531 }}>
      <DialogTitle>{label}</DialogTitle>
      <DialogContent style={{ minWidth: 685 }}>
        <CodingActions {...props} onComplete={onTransition} onFailed={close} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary" variant="contained">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function SummaryActions({ transition, onTransitionComplete }: WorksheetApis) {
  const actions = transition((s) => s.actions);
  const onTransitionFailed = () => {
    //TODO: show error message
  };

  return (
    <Paper>
      <CodingActions onComplete={onTransitionComplete} onFailed={onTransitionFailed} transition={transition} actions={actions} />
    </Paper>
  );
}
